import { Component, Input } from '@angular/core';
import { menuItems } from '../menu';
import { DeviceService } from 'projects/max/dfup-storeupweb-fe/src/app/service/device.service';

@Component({
  selector: 'app-hamburger-menu',
  templateUrl: './hamburger-menu.component.html',
  styleUrls: ['./hamburger-menu.component.scss']
})
export class HamburgerMenuComponent {
  @Input() items!: unknown[];
  protected readonly menuItems = menuItems;

  constructor(public deviceSvc: DeviceService) {
  }
}
